<template>
    <section class="shadow-lg p-4 gap-1.5 bg-white rounded-lg w-80">
        <Handle type="target" :position="Position.Left" />
        <article class="flex items-center gap-2">
            <article class="bg-primary-950 rounded-md p-2 inline-block">
                <Icon icon="fluent:list-bar-20-regular" class="text-xl text-white"/>
            </article>
            <input type="text" placeholder="Field Name" v-model="data.name" 
                   class="block font-bold text-sm w-full outline-none border p-2 rounded-lg"/>
        </article>

        <article>
            <input type="text" placeholder="Label" v-model="data.name" class="mt-2 text-sm w-full outline-none border p-2 rounded-lg"/>
            <span class="font-bold text-xs px-1">Options</span>
            <section v-for="value in 1" :key="value">
                <section class="flex items-center gap-1">
                    <button>
                        <Icon icon="codex:menu" class="text-2xl" />
                    </button>
                    <input type="text" placeholder="Value" v-model="data.name" class="block mt-1 text-sm w-full outline-none border p-2 rounded-lg"/>
                   
                    <button>
                        <Icon icon="ep:remove-filled" class="text-2xl text-red-600" />
                    </button>
                </section>
            </section>
            <section>
                <button class="text-xs p-1 mt-2 text-blue-500 font-bold">Add Option</button>
            </section>
        </article>

        <Handle type="source" :position="Position.Right" />
    </section>
</template>

<script setup>
import { ref } from "vue"
import { Icon } from "@iconify/vue"
import { Handle, Position } from '@vue-flow/core'

// const model = useNode();

const data = ref({
    name: null,
    text: null,
});
</script>